import { assert, isDefined } from '@sama/js-core';
import { isUndefined } from 'lodash';
import { ObjectState } from '../../../../../cross-team-shared/annotation/shared/state/object-state';
import {
  DeleteObjectLocationOperation,
  ObjectLocationOperationAttributes,
} from '../../../../../team-apis/otterdam/annotation-operations/object-operations';
import { ObjectLocationOperationBuilderParams } from './object-operation-builder-params';

export function createDeleteObjectLocationBuilders({
  currentObject,
  locations,
}: ObjectLocationOperationBuilderParams) {
  return locations.map(
    (location) =>
      new DeleteObjectLocationOperationBuilder(
        location.frameNumber,
        currentObject,
        location.operationAttributes,
      ),
  );
}

export class DeleteObjectLocationOperationBuilder {
  constructor(
    private frameNumber: number,
    private objectState?: ObjectState,
    private locationAttributes?: ObjectLocationOperationAttributes,
  ) {}

  canBuild() {
    return isDefined(this.objectState) && isUndefined(this.locationAttributes);
  }

  build(): DeleteObjectLocationOperation {
    assert(
      this.objectState,
      'object should be defined for deleting object location',
    );
    return buildDeleteObjectLocationOperation(
      this.objectState.index,
      this.frameNumber,
    );
  }
}

export function buildDeleteObjectLocationOperation(
  objectId: number,
  frameNumber: number,
): DeleteObjectLocationOperation {
  return {
    operation: 'DELETE_OBJECT_LOCATION',
    ids: { objectId, frameNumber },
  };
}
